import { useI18n } from '../lib/i18n';
import { useLogout } from '../lib/session';
import { LanguagePicker, Logo } from '../components/ui';
import { TwoFactor } from '../components/TwoFactor';

/**
 * The wall an owner or administrator meets when the studio requires a code and
 * their account has none. Shown instead of the portal, the way the forced
 * password change is: the guard would refuse every screen behind it anyway.
 */
export function TwoFactorSetupPage() {
  const { t } = useI18n();
  const logout = useLogout();

  return (
    <main className="grid min-h-dvh place-items-center px-5 pb-[max(2.5rem,env(safe-area-inset-bottom))] pt-[max(2.5rem,env(safe-area-inset-top))]">
      <div className="w-full max-w-sm">
        <div className="mb-9 flex flex-col items-center gap-5 text-center">
          <Logo withWordmark size="lg" />
          <h1 className="font-display text-3xl font-bold tracking-tight text-ink">
            {t('twofa.setupTitle')}
          </h1>
        </div>

        <TwoFactor forced />

        {/* The portal is closed behind this screen, so the only way to change
            language is the one offered here. */}
        <LanguagePicker className="mt-4 justify-center" />

        <button
          type="button"
          onClick={() => logout.mutate()}
          className="mx-auto mt-2 block min-h-11 text-xs text-ink-faint transition hover:text-ink-dim"
        >
          {t('password.signOutInstead')}
        </button>
      </div>
    </main>
  );
}
